/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {executeSetName} from '../api'

export const useMutationExecuteSetName = createReactQueryMutationHook('executeSetName', executeSetName)
